import { useEffect, lazy, Suspense } from 'react';
import { initAnalytics, trackPageView } from './lib/analytics';

const LandingHub = lazy(() => import('./pages/LandingHub'));
const AudiencePage = lazy(() => import('./pages/AudiencePage'));

function Router() {
  const path = window.location.pathname;

  useEffect(() => {
    trackPageView(path);
  }, [path]);

  // Audience-specific pages: /for/rv-owners, /for/rv-park-owners, etc.
  if (path.startsWith('/for/')) {
    const slug = path.replace('/for/', '').replace(/\/$/, '');
    return (
      <Suspense fallback={<PageLoader />}>
        <AudiencePage slug={slug} />
      </Suspense>
    );
  }

  // Default: landing hub
  return (
    <Suspense fallback={<PageLoader />}>
      <LandingHub />
    </Suspense>
  );
}

function PageLoader() {
  return (
    <div className="min-h-screen bg-[#0C1A0E] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin" />
        <p className="text-text-tertiary text-sm font-medium tracking-wider uppercase">Loading</p>
      </div>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <main>
      <Router />
    </main>
  );
}
